<template>
  <div>
    <app-pagination-a-m
      v-model="pagina"
      :total-pages="computedTotalPages || 0"
      :total-registros="totalRegistros"
      :per-page="porPagina"
      :paginate-by="paginateBy"
      :disabled-select-total="disabledSelectTotal"
      :show-per-page-selector="showPerPageSelector"
      @change="cambiarPagina"
      @update:perPage="updatePerPageValue"
      @page-changed="onPageChanged"
      class="principalPagination"
    ></app-pagination-a-m>
  </div>
</template>

<script>
import AppPaginationAM from "../views/acciones-movimientos/components/AppPagination.vue";
export default {
  name: "AppPagination",
  components: {
    AppPaginationAM
  },
  props: {
    value: {
      type: Number,
      default: 1,
    },
    page: {
      type: Number,
      default: 1,
    },
    totalRegistros: {
      type: Number,
      default: 0,
    },
    perPage: {
      type: Number,
      default: 10,
    },
    totalPages: {
      type: Number,
      default: 0,
    },
    paginateBy: {
      type: Array,
      default: () => [5, 10, 20, 50, 100],
    },
    disabledSelectTotal: {
      type: Boolean,
      default: false,
    },
    showPerPageSelector: {
      type: Boolean,
      default: true,
    }
  },

  methods: {
    cambiarPagina() {
      this.$emit("input", this.pagina);
      this.$emit("change");
    },
    updatePerPageValue(newValue) {
      this.porPagina = newValue;
      this.$emit("update:perPage", newValue);
    },
    onPageChanged(page) {
      this.$emit("input", page);
      this.$emit("page-changed", page);
    },
  },
  computed: {
    pagina: {
      get() {
        if (this.$options.propsData && 'page' in this.$options.propsData) {
          return this.page;
        }
        // Si hay un listener de input, se está usando v-model, usa value
        // Si no, se está usando :page.sync, usa page
        return this.$listeners.input ? this.value : this.page;
      },
      set(value) {
        this.$emit("update:page", value);
        this.$emit("input", value);
      },
    },
    porPagina: {
      get() {
        return this.perPage;
      },
      set(value) {
        this.$emit("update:perPage", value);
      },
    },
    computedTotalPages() {
      if (this.$options.propsData && 'totalPages' in this.$options.propsData && this.totalPages > 0) {
        return this.totalPages;
      }
      return Math.ceil(this.totalRegistros / this.perPage);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .principalPagination .pagination {
  display: flex !important;
}

::v-deep .principalPagination .app-pagination-wrapper {
  width: 100%;
}

::v-deep .principalPagination .mt-7 {
  margin-top: 0 !important;
}
</style>
